import {Routes} from '@angular/router';
import {OktaCallbackComponent} from '@okta/okta-angular';
import {HomeComponent} from 'src/app/modules/home/home.component';
import {AppGuard} from 'src/app/tinea-components/okta/auth/guards/app-guard';
import {RouteId} from './enums/env/routes-id-enum';
import {DashboardGuard} from './modules/dashboard/guards/dashboard-guard';
import {RoutingService} from './services/Routing.service';
import {DashboardGNLGuard} from 'src/app/modules/dashboard-gnl/guards/dashboard-gnl-guard';
import {TicketGuard} from 'src/app/modules/tickets/guards/ticket-guard';
import {AlarmGuard} from 'src/app/modules/alarms/guards/alarm-guard';
import {StationGuard} from 'src/app/modules/stations/guards/station-guard';
import {GraphGuard} from 'src/app/modules/graphs/guards/graph-guard';
import {CustomerAccountsGuard} from './modules/customer-accounts/guards/customer-accounts-guard.service';
import {BadgeGuard} from 'src/app/modules/badges/guards/badge-guard';
import {tabIndicatorResolver} from 'src/app/modules/badges/resolvers/tab-indicator.resolver';
import {AdministrationGuard} from 'src/app/modules/administration/guards/administration-guard';
import {ErrorComponent} from 'src/app/shared/components/error/error.component';
import {
  OktaCustomCallBackComponent
} from 'src/app/tinea-components/okta/components/okta-custom-call-back/okta-custom-call-back.component';
import {
  LoggedInCallBackComponent
} from 'src/app/tinea-components/okta/components/logged-in-call-back/logged-in-call-back.component';
import {priceTabIndicatorResolver} from 'src/app/modules/stations/resolvers/price-tab-indicator.resolver';
import {
  connectivityTabIndicatorResolver
} from 'src/app/modules/dashboard/resolvers/connectivity-tab-indicator.resolver';

export const routes: Routes = [
  { path: 'implicit/callback', component: OktaCallbackComponent },
  { path: 'logged-in-callback', component: LoggedInCallBackComponent },
  { path: 'implicit/custom-callback', component: OktaCustomCallBackComponent },
  {
    path: '',
    canActivate: [AppGuard],
    component: HomeComponent,
    pathMatch: 'full',
  },
  {
    path: RoutingService.getPathRoute(RouteId.DASHBOARD),
    canActivate: [AppGuard, DashboardGuard],
    resolve: { tabIndicators: connectivityTabIndicatorResolver },
    loadChildren: () => import('./modules/dashboard/dashboard.module').then(m => m.DashboardModule)
  },
  {
    path: RoutingService.getPathRoute(RouteId.DASHBOARD_GNL),
    canActivate: [AppGuard, DashboardGNLGuard],
    loadChildren: () => import('./modules/dashboard-gnl/dashboard-gnl.module').then(m => m.DashboardGNLModule)
  },
  {
    path: RoutingService.getPathRoute(RouteId.TICKETS),
    canActivate: [AppGuard, TicketGuard],
    loadChildren: () => import('./modules/tickets/tickets.module').then(m => m.TicketsModule)
  },
  {
    path: RoutingService.getPathRoute(RouteId.MAP),
    canActivate: [AppGuard],
    loadChildren: () => import('./modules/map/map.module').then(m => m.MapModule)
  },
  {
    path: RoutingService.getPathRoute(RouteId.ALARMS),
    canActivate: [AppGuard, AlarmGuard],
    loadChildren: () => import('./modules/alarms/alarms.module').then(m => m.AlarmsModule)
  },
  {
    path: RoutingService.getPathRoute(RouteId.EMS),
    canActivate: [AppGuard],
    loadChildren: () => import('./modules/ems/ems.module').then(m => m.EmsModule)
  },
  {
    path: RoutingService.getPathRoute(RouteId.STATIONS),
    canActivate: [AppGuard, StationGuard],
    loadChildren: () => import('./modules/stations/stations.module').then(m => m.StationsModule),
    resolve: { tabIndicators: priceTabIndicatorResolver },
  },
  {
    path: RoutingService.getPathRoute(RouteId.CALCULATED_GLOBAL_TAGS_PAGE),
    canActivate: [AppGuard, StationGuard],
    loadChildren: () => import('./modules/calculated-tags/calculated-tags-global/calculated-global-tags.module').then(m => m.CalculatedGlobalTagsModule)
  },
  {
    path: RoutingService.getPathRoute(RouteId.GRAPHS),
    canActivate: [AppGuard, GraphGuard],
    loadChildren: () => import('./modules/graphs/graphs.module').then(m => m.GraphsModule)
  },
  {
    path: RoutingService.getPathRoute(RouteId.CUSTOMER_ACCOUNTS),
    canActivate: [AppGuard, CustomerAccountsGuard],
    loadChildren: () => import('./modules/customer-accounts/customer-accounts.module').then(m => m.CustomerAccountsModule)
  },
  {
    path: RoutingService.getPathRoute(RouteId.BADGES),
    canActivate: [AppGuard, BadgeGuard],
    resolve: { tabIndicators: tabIndicatorResolver },
    data: {
      routeId: RouteId.BADGES,
    },
    loadChildren: () => import('./modules/badges/badges.module').then(m => m.BadgesModule)
  },
  {
    path: RoutingService.getPathRoute(RouteId.NOTIFICATIONS),
    canActivate: [AppGuard],
    loadChildren: () => import('./modules/notifications/notifications.module').then(m => m.NotificationsModule)
  },
  {
    path: RoutingService.getPathRoute(RouteId.ADMINISTRATION),
    canActivate: [AppGuard, AdministrationGuard],
    loadChildren: () => import('./modules/administration/administration.module').then(m => m.AdministrationModule)
  },
  {
    path: RoutingService.getPathRoute(RouteId.TRANSACTIONS),
    canActivate: [AppGuard, AdministrationGuard],
    loadChildren: () => import('./modules/transactions/transactions.module').then(m => m.TransactionsModule)
  },
  {
    path: RoutingService.getPathRoute(RouteId.CALCULATED_TAG_PAGE),
    canActivate: [AppGuard, AdministrationGuard],
    loadChildren: () => import('./modules/calculated-tags/calculated-tag-edit/calculated-tag.module').then(m => m.CalculatedTagModule)
  },
  {
    path: RoutingService.getPathRoute(RouteId.CALCULATED_TAG_CREATE_PAGE),
    canActivate: [AppGuard, AdministrationGuard],
    loadChildren: () => import('./modules/calculated-tags/calculated-tag-create/calculated-tag-create.module').then(m => m.CalculatedTagCreateModule)
  },
  {
    path: RoutingService.getPathRoute(RouteId.CUSTOMER_ACCOUNTS_SUB_SERVICE),
    canActivate: [AppGuard, AdministrationGuard],
    loadChildren: () => import('./modules/customer-account-sub-service/customer-account-sub-service.module').then(m => m.CustomerAccountSubServiceModule)
  },
  {
    path: RoutingService.getPathRoute(RouteId.DEMO),
    canActivate: [AppGuard],
    loadChildren: () => import('./modules/demo/demo.module').then(m => m.DemoModule)
  },
  {
    path: RoutingService.getPathRoute(RouteId.EWON),
    canActivate: [AppGuard, StationGuard],
    loadChildren: () => import('./modules/ewon/ewon.module').then(m => m.EwonModule)
  },
  {
    path: 'error',
    canActivate: [AppGuard],
    component: ErrorComponent,
    pathMatch: 'full',
  },
  // a wildcard route to intercept invalid URLs
  { path: '**', redirectTo: 'error', pathMatch: 'full' }
];
